export default {
  desktop: '1024px',
  tablet: '768px',
  mobile: '579px',
};
